module.exports = __webpack_public_path__ + "img/pagination-desktop-7items.430b9a70.png";